(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-einstant/assets/javascripts/shared/hooks/use-ticket-info.js') >= 0) return;  svs.modules.push('/modules/tickets-einstant/assets/javascripts/shared/hooks/use-ticket-info.js');
"use strict";


const {
  useEffect,
  useState
} = React;
const useTicketInfo = _ref => {
  let {
    wager,
    gameId
  } = _ref;
  const {
    getTicketInfoByUrl,
    getTicketInfoByWager
  } = svs.eInstant.lobby.play.utils;
  const [loading, setLoading] = useState(Boolean(gameId || wager));
  const [ticketInfo, setTicketInfo] = useState(null);
  useEffect(() => {
    const fetchAllGames = async () => {
      try {
        const allGames = await svs.eInstant.shared.util.fetchAllGames();
        const game = wager ? getTicketInfoByWager(wager, allGames) : getTicketInfoByUrl(gameId, allGames);
        setTicketInfo(game);
        if (!game) {
          svs.eInstant.logger.warn("No game found for gameId: ".concat(gameId));
        }
      } catch (e) {
        svs.eInstant.logger.error('Failed to fetch games', e);
      } finally {
        setLoading(false);
        svs.ui.loader.hide();
      }
    };
    if (!gameId && !wager) {
      setTicketInfo(null);
      return;
    }
    svs.ui.loader.show();
    const game = wager ? getTicketInfoByWager(wager) : getTicketInfoByUrl(gameId);
    if (game) {
      setTicketInfo(game);
      setLoading(false);
      svs.ui.loader.hide();
    } else {
      fetchAllGames();
    }
  }, [gameId]);
  return {
    ticketInfo,
    loading
  };
};
setGlobal('svs.eInstant.shared.hooks.useTicketInfo', useTicketInfo);

 })(window);